import { Button, defaultIconSize } from '@synqo/frontend-component-library';
import { IconDownload } from '@tabler/icons-react';
import styles from './InvoiceSnapshotExportButton.module.css';

interface InvoiceSnapshotExportButtonProps {
    onClick: () => void;
}

/** Opens the invoice export dialog. */
// @ai-generated 2026-09-28T14:03:12+00:00 by philipp.kammerer@synqony.com using Claude Opus 5.5 (1M context)
export function InvoiceSnapshotExportButton({ onClick }: InvoiceSnapshotExportButtonProps) {
    return (
        <div className={styles.slot}>
            <Button appearance="outlined" onClick={onClick} tooltip="Rechnungen exportieren">
                <IconDownload size={defaultIconSize} />
                &nbsp;Exportieren
            </Button>
        </div>
    );
}
